// extracted by mini-css-extract-plugin
export default {"items":"items_items__0gj04"};